export default __webpack_public_path__ + "static/media/new.88fbc7a3.png";